import { render, staticRenderFns } from "./bond-proof.vue?vue&type=template&id=5477cbc2&scoped=true"
import script from "./bond-proof.vue?vue&type=script&lang=js"
export * from "./bond-proof.vue?vue&type=script&lang=js"
import style0 from "./bond-proof.vue?vue&type=style&index=0&id=5477cbc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5477cbc2",
  null
  
)

export default component.exports